import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeSetLikeMarker, GeometryAttributeSetNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import {GeometryGraphPoint} from "#template/nodes/geometry-graph/output/geometry-graph-point"

import type {PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import {createPointGeometryAttributeSetData} from "#template/nodes/geometry-graph/interfaces"
import type {GeometryAttributeSetData} from "#template/nodes/geometry-graph/interfaces"
import type {NonNullableParameters} from "#template/nodes/geometry-graph/common/geometry-graph-node"

export type PointGeometryAttributeSetPointLikeInputParameters = {
    point: GeometryGraphPoint | null
}

const definition: TemplateNodeDefinition<PointGeometryAttributeSetPointLikeInputParameters> = {
    nodeClass: "PointGeometryAttributeSetPointLikeInput",
    validation: {
        parameters: z.object({
            point: z.nullable(graphNode(GeometryGraphPoint)),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryAttributeSetPointLikeInput
    extends GeometryAttributeSetNode<0, PointGeometryAttributeSetPointLikeInputParameters>
    implements PointGeometryAttributeSetLikeNode
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    protected override hasValidParameters(
        parameters: PointGeometryAttributeSetPointLikeInputParameters,
    ): parameters is PointGeometryAttributeSetPointLikeInputParameters & NonNullableParameters<PointGeometryAttributeSetPointLikeInputParameters> {
        return parameters.point !== null
    }

    protected override setupGeometryData(): {evaluatedGeometryData: BuilderInlet<GeometryAttributeSetData<0> | null>} {
        // TODO: Fill in once the set of standard attributes for point geometry is defined, for now return empty set
        return {evaluatedGeometryData: createPointGeometryAttributeSetData({})}
    }
}
